import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../shared/utility";


const initialState = {
    error: null,
    loading: false,
    isOpen: false,
    selectedTopic: null
}


const setError = (state, action) => {
    return updateObject(state, {error: action.error})
}
const setLoading = (state, action) => {
    return updateObject(state, {
        loading: !!action.loading
    });
}

const setOpen = (state, action) => {
    return updateObject(state, {
        isOpen: action.isOpen,
        selectedTopic: action.selectedTopic
    })
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_MESSAGE_ERROR:
            return setError(state, action);
        case actionTypes.SET_MESSAGE_LOADING:
            return setLoading(state, action);
        case actionTypes.SET_MESSAGE_RESET:
            return initialState
        case actionTypes.SET_MESSAGE_OPEN:
            return setOpen(state, action)
        default:
            return state;
    }
};

export default reducer;